import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const StyledWarningButton = styled.button`
    width: 150px;
    height: 35px;
    background-color: white;
    color: ${(props) => props.theme.color.warning};
    font-size: 12px;
    font-weight: 600;
    border: solid 1px ${(props) => props.theme.color.warning};
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    cursor: pointer;
    padding-bottom: 4px;
    user-select: none;
    border-radius: 2px;

    &:hover:enabled {
        background-color: ${(props) => props.theme.color.lightwarning};
    }
    :active:enabled {
        box-shadow: 0 0 3px ${(props) => props.theme.color.warninghover};
    }
    :disabled {
        color: ${(props) => props.theme.color.gray};
        background-color: ${(props) => props.theme.color.disabledgray}
    }
`;

function WarningButton(props) {

    const {caption, isLoading, ...restProps} = props;

    return (
        <StyledWarningButton {...restProps}>
            {isLoading && <FontAwesomeIcon icon={faSpinner} className='spinner' spin style={{marginRight: 5}}></FontAwesomeIcon>}
            {caption}
        </StyledWarningButton>
    )
}

export default WarningButton;